export default `
query SiteServiceFrequencies($siteId: Int!, $serviceId: String!, $subServiceId: String!) {
  siteServiceFrequencies(siteId: $siteId, serviceId: $serviceId, subServiceId: $subServiceId) {
    id
    description
  }
}
`
